export default __webpack_public_path__ + "static/media/tm.373d2a50.jpg";